import { Drawer } from '@blueprintjs/core';
import SiteDrawerData from 'Data/SiteDrawerData';
import DataManager from 'Lib/DataManager';
import { useStateWithRef } from 'Lib/hooks/useStateWithRef';
import { useEffect, useRef, useState } from 'react';
import styles from './SiteDrawerContainer.module.css';

let DM = new DataManager();

const SiteDrawerContainer = () => {
  const [drawerProperties, setDrawerProperties, drawerPropertiesRef] =
    useStateWithRef(SiteDrawerData.defaultDrawerProperties);
  const isResizingRef = useRef(false);
  const [width, setWidth] = useState(
    SiteDrawerData.defaultDrawerProperties.size.defaultWidth,
  );

  useEffect(() => {
    DM.add(
      SiteDrawerData.registerListener('DRAWER_OPENED', drawerOpened),
      SiteDrawerData,
    );
    DM.add(
      SiteDrawerData.registerListener('DRAWER_CLOSED', drawerClosed),
      SiteDrawerData,
    );
    DM.add(
      SiteDrawerData.registerListener('DRAWER_CLEARED', drawerCleared),
      SiteDrawerData,
    );
    return () => {
      DM.clear();
    };
  }, []);

  useEffect(() => {
    setWidth(drawerProperties.size.defaultWidth);
  }, [drawerProperties]);

  const handleMousedown = () => {
    isResizingRef.current = true;
  };

  const handleMouseup = () => {
    isResizingRef.current = false;
  };

  const handleMousemove = (e) => {
    // we don't want to do anything if we aren't resizing.
    if (!isResizingRef?.current) {
      return;
    }
    e.preventDefault();

    if (e.clientX <= 60) {
      return;
    }

    let sizeObject =
      drawerPropertiesRef?.current?.size ||
      SiteDrawerData.defaultDrawerProperties.size;
    let offsetRight =
      document.body.offsetWidth - (e.clientX - document.body.offsetLeft);
    let minWidth = sizeObject.minWidth;
    if (offsetRight > minWidth) {
      setWidth(offsetRight);
    }
  };

  const drawerOpened = (newDrawerProperties) => {
    setDrawerProperties(newDrawerProperties);
    document.addEventListener('mousemove', handleMousemove);
    document.addEventListener('mouseup', handleMouseup);
  };

  const drawerClosed = (newDrawerProperties) => {
    setDrawerProperties(newDrawerProperties);
    document.removeEventListener('mousemove', handleMousemove);
    document.removeEventListener('mouseup', handleMouseup);
  };

  const resetProperties = (newDrawerProperties) => {
    setDrawerProperties({
      ...{
        ...SiteDrawerData.defaultDrawerProperties,
      },
      ...newDrawerProperties,
    });
    isResizingRef.current = false;
  };

  const drawerCleared = (newDrawerProperties) => {
    resetProperties(newDrawerProperties);
  };

  return (
    <Drawer
      hasBackdrop={false}
      size={width}
      isOpen={drawerProperties.isOpen}
      onClose={SiteDrawerData.close}
      title={drawerProperties.title}
      icon={drawerProperties.icon}>
      <div
        onMouseDown={handleMousedown}
        onMouseUp={handleMouseup}
        className={styles.width_resize_bar}
      />
      <div className={styles.drawer_background}>{drawerProperties.content}</div>
    </Drawer>
  );
};

export default SiteDrawerContainer;
